import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@/model/selectors';

export function useIsGenworthMode() {
  const featureFlags = useSelector(selectFeatureFlags);

  return !!featureFlags.genworthMode;
}
